// this is based on https://github.com/taoeffect/vue-script2

const loaded = {}

/* eslint-disable prefer-promise-reject-errors */
export default {
  load (src, opts = { parent: document.head }) {
    return new Promise((resolve, reject) => {
      if (loaded[src]) {
        return resolve()
      }

      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = false
      script.src = src

      script.onload = () => {
        loaded[src] = true
        resolve()
      }

      script.onerror = () => {
        reject()
      }

      document.head.appendChild(script)
    })
  }
}
